import { teamRolesUrl } from "@app/routes";
import { Link } from "react-router-dom";

export const TopPlanBannerContactOwner = () => {
  return (
    <span className="text-gray-600">
      Contact an{" "}
      <Link to={teamRolesUrl()} className="text-gray-800 underline">
        Account Owner
      </Link>{" "}
      to upgrade.
    </span>
  );
};
